import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from 'react';
import { useContextSelector } from 'use-context-selector';
import chatInit from './chat';
import { css, GlobalStyles } from '../../../styled';
import TopbarContext from '../context';
const TopbarUnitySupportChat = () => {
    const user = useContextSelector(TopbarContext, context => context.user);
    useEffect(() => {
        if (!(user === null || user === void 0 ? void 0 : user.isClubeBlack))
            return;
        const destroy = chatInit(user);
        return () => destroy();
    }, [user]);
    return (_jsx(GlobalStyles, { styles: css `
        #lhc_status_widget_v2 {
          left: auto !important;
          bottom: 0 !important;
          z-index: 102 !important;
        }
      ` }));
};
export default TopbarUnitySupportChat;
